    <ui-table
      [data]="complianceIssues"
      [templates]="[

        {
          title: 'translate.complianceIssue.explanation',
          template: explanation,
          colClass: 'claim-consistencies-table-column claim-consistencies-table-nobreaks-column'
        },
          {
          title: 'translate.complianceIssue.action',
          template: actions,
          colClass: 'claim-consistencies-table-column claim-consistencies-table-actions-column'
        }
    ]"
    >
    </ui-table>

    <ng-template #explanation let-row="row">
            <span *ngIf="row.explanation">{{ row.explanation }}</span>
    </ng-template>

      <ng-template #actions let-row="row">

                <a (click)="removeComplianceIssue(row)" [class.disabled]="disableActions">
                  <i [class.disabled]="disableActions" class="fa-solid fa-xmark" tooltip="{{ 'translate.general.remove' | translate  }}"></i>
                </a>
            
    </ng-template>